import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'

const UIButtonIcon = ({ children, onClick, dynamicStyle }) => {
  return (
    <span onClick={onClick} className={css(styles.container, dynamicStyle)}>
      {children}
    </span>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'inline-block',
    padding: 15,
    cursor: 'pointer',
  },
})

UIButtonIcon.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  dynamicStyle: PropTypes.object,
}

export default UIButtonIcon
